var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 15 14.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.562,18.787l5.357-5.357a1.255,1.255,0,1,0-1.775-1.775l-5.357,5.357L13.43,11.654a1.255,1.255,0,1,0-1.775,1.775l5.357,5.357-5.357,5.357a1.255,1.255,0,1,0,1.775,1.775l5.357-5.357,5.357,5.357a1.255,1.255,0,1,0,1.775-1.775Z",
    transform: "translate(-11.285 -11.289)",
    fill: "#E0E0E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.0da437d02cbb55ca87e67cdb8d750b57.svg";
export { ForwardRef as ReactComponent };